// Les documents scannés vivent tous dans la collection `invoices` : c'est
// `type_depense` qui sépare la dépense reçue de la facture émise par
// l'utilisateur et scannée depuis l'application (onglet « Émises Scannées »
// côté mobile). Sans ce tri, la liste des dépenses mélange les deux sens.

export const TYPE_EMISE_SCANNEE = "Émise";

export function isEmiseScannee(invoice: { type_depense?: string }) {
  return invoice.type_depense === TYPE_EMISE_SCANNEE;
}

// Tout ce qui n'est pas explicitement « Émise » reste une dépense : une valeur
// absente ou inattendue ne doit disparaître d'aucune des deux listes.
export function splitInvoicesByType<T extends { type_depense?: string }>(
  invoices: T[],
) {
  return {
    depenses: invoices.filter((i) => !isEmiseScannee(i)),
    emisesScannees: invoices.filter(isEmiseScannee),
  };
}
